import * as actions from "./actions";

export const initialState = {
  autogiroApproving: {
    sending: false,
    send: false,
    data: {},
  },

  autogiroBulkApprove: {
    sending: false,
    send: false,
    error: "",
  },

  autogiroPending: {
    fetching: false,
    fetched: false,
    data: [],
    table: {
      currentFilter: null,
      pagination: { page: 1, take: 20 },
    },
  },

  autogiroCompleted: {
    fetching: false,
    fetched: false,
    data: [],
    table: {
      currentFilter: null,
      pagination: { page: 1, take: 20 },
    },
  },
  autogiroCompleteRequest: {},
  autogiroDeleteRequest: {},
};

export default function autogiroSubreducer(state, action) {
  switch (action.type) {
    case actions.AUTOGIRO_GET_COMPLETED_REQUEST: {
      return Object.assign({}, state, {
        autogiroCompleted: Object.assign({}, state.autogiroCompleted, {
          fetching: true,
        }),
      });
    }
    case actions.AUTOGIRO_GET_COMPLETED_SUCCESS: {
      return Object.assign({}, state, {
        autogiroCompleted: Object.assign({}, state.autogiroCompleted, {
          fetched: true,
          fetching: false,
          testsetest: "testsetset",
          data: action.response,
        }),
      });
    }
    case actions.AUTOGIRO_GET_PENDING_REQUEST: {
      return Object.assign({}, state, {
        autogiroPending: Object.assign({}, state.autogiroPending, {
          fetching: true,
        }),
      });
    }
    case actions.AUTOGIRO_GET_PENDING_SUCCESS: {
      return Object.assign({}, state, {
        autogiroPending: Object.assign({}, state.autogiroPending, {
          fetched: true,
          fetching: false,
          data: action.response,
        }),
      });
    }
    case actions.AUTOGIRO_COMPLETE_REQUEST: {
      return Object.assign({}, state, {
        autogiroCompleteRequest: {
          sending: true,
        },
      });
    }
    case actions.AUTOGIRO_COMPLETE_SUCCESS: {
      return Object.assign({}, state, {
        autogiroCompleteRequest: {
          sending: false,
          completedOrder: action.additionalData,
          msg: (
            <p style={{ color: "green" }}>Autogiro request set as completed</p>
          ),
        },
      });
    }
    case actions.AUTOGIRO_COMPLETE_ERROR: {
      return Object.assign({}, state, {
        autogiroCompleteRequest: {
          sending: false,
          msg: (
            <p style={{ color: "red" }}>
              Error when trying to complete the autogiro request
            </p>
          ),
        },
      });
    }
    case actions.AUTOGIRO_DELETE_REQUEST: {
      return Object.assign({}, state, {
        autogiroDeleteRequest: {
          sending: true,
        },
      });
    }
    case actions.AUTOGIRO_DELETE_SUCCESS: {
      return Object.assign({}, state, {
        autogiroDeleteRequest: {
          sending: false,
          deletedOrder: action.additionalData,
          msg: (
            <p style={{ color: "green" }}>Autogiro request set as deleted</p>
          ),
        },
      });
    }
    case actions.AUTOGIRO_DELETE_ERROR: {
      return Object.assign({}, state, {
        autogiroDeleteRequest: {
          sending: false,
          msg: (
            <p style={{ color: "red" }}>
              Error when trying to delete the autogiro request
            </p>
          ),
        },
      });
    }
    case actions.AUTOGIRO_CLEAR_AFTER_ACTION_CONFIRM_MSG: {
      let pending = state.autogiroPending.data.slice();
      let completed = state.autogiroCompleted.data.slice();
      let completedItem;
      let removePendingIndex;

      if (state.autogiroCompleteRequest.completedOrder) {
        for (var i = 0; i < pending.length; i++) {
          let order = pending[i];
          removePendingIndex = i;
          if (
            order.OrderId ===
            state.autogiroCompleteRequest.completedOrder.OrderId
          ) {
            completedItem = state.autogiroCompleteRequest.completedOrder;
            break;
          }
        }

        pending.splice(removePendingIndex, 1);
        completed.unshift(completedItem);
      }

      // remove from pending all deleted orders as well, do not add them to completed though
      if (state.autogiroDeleteRequest.deletedOrder) {
        for (var d = 0; d < pending.length; d++) {
          let order = pending[d];
          removePendingIndex = d;
          if (
            order.OrderId === state.autogiroDeleteRequest.deletedOrder.OrderId
          ) {
            break;
          }
        }

        pending.splice(removePendingIndex, 1);
      }

      return Object.assign({}, state, {
        autogiroCompleteRequest: {
          sending: false,
        },
        autogiroPending: Object.assign({}, state.autogiroPending, {
          data: pending,
        }),
        autogiroCompleted: Object.assign({}, state.autogiroCompleted, {
          data: completed,
        }),
      });
    }

    case actions.AUTOGIRO_ALL_PENDING_COMPLETE_REQUEST:
      return Object.assign({}, state, {
        autogiroBulkApprove: Object.assign({}, state.autogiroBulkApprove, {
          sending: true,
        }),
      });

    case actions.AUTOGIRO_ALL_PENDING_COMPLETE_SUCCESS:
      return Object.assign({}, state, {
        autogiroBulkApprove: Object.assign({}, state.autogiroBulkApprove, {
          send: true,
          sending: false,
        }),
      });

    case actions.AUTOGIRO_ALL_PENDING_COMPLETE_ERROR:
      return Object.assign({}, state, {
        autogiroBulkApprove: Object.assign({}, state.autogiroBulkApprove, {
          error: action.response ? action.response : "something went wrong",
          sending: false,
        }),
      });

    case actions.AUTOGIRO_ALL_PENDING_CLOSE_DIALOG:
      return Object.assign({}, state, {
        autogiroBulkApprove: {
          sending: false,
          send: false,
          error: "",
        },
      });

    default:
      return state;
  }
}
